import { Stack } from "@mui/material";
import React from "react";

export default function RowStack({
  children,
  padding = 0,
  justifyContent,
  alignItems,
}) {
  return (
    <Stack
      p={padding}
      direction={"row"}
      justifyContent={justifyContent ? justifyContent : "space-between"}
      alignItems={alignItems ? alignItems : "center"}
    >
      {children}
    </Stack>
  );
}
